module.exports = __webpack_public_path__ + "img/60.3d2066ff.png";